<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 18px;
  box-sizing: border-box;
  background: #f3f3f3;
  position: relative;
  .edit-teacher {
    width: 420px;
    height: 200px;
    position: absolute;
    background: #fff;
    z-index: 99;
    line-height: 36px;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
    border: 1px #c9c9c9 solid;
    padding: 12px 24px;
    box-sizing: border-box;
    overflow: hidden;
    .header {
      width: 100%;
      margin-top: 12px;
      .cancel {
        position: absolute;
        bottom: 24px;
        background: #fff;
        color: rgb(88, 88, 88);
        right: 80px;
      }
      .sure {
        position: absolute;
        bottom: 24px;
        right: 10px;
      }
    }
  }
  .tips {
    width: 420px;
    height: 150px;
    position: absolute;
    background: #fff;
    z-index: 99;
    line-height: 36px;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
    p {
      font-size: 24px;
    }
    .cancel {
      position: absolute;
      bottom: 24px;
      background: #fff;
      color: rgb(88, 88, 88);
      right: 80px;
    }
    .sure {
      position: absolute;
      bottom: 24px;
      right: 10px;
    }
  }
  .header {
    position: relative;
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 48px;
    background: #fff;
    padding: 9px 10px;
    box-sizing: border-box;
    display: flex;
    .loginButton {
      width: 50px;
      height: 30px;
    }
    .search {
      position: absolute;
      width: 360px;
      height: 30px;
      display: flex;
      right: 10px;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .footer {
    position: relative;
    height: 144px;
    width: 100%;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 48px 10px;
    box-sizing: border-box;
  }
  .create-new {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 600px;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 9999;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      line-height: 36px;
      font-weight: 600;
      .back {
        width: 72px;
        height: 48px;
      }
      .message {
        width: 98px;
        height: 48px;
        text-align: center;
      }
    }
    .content {
      width: 100%;
      height: 300px;
      margin-top: 20px;
      .tab-tips {
        width: 100%;
        height: 48px;
        font-size: 16px;
        line-height: 48px;
        display: flex;
        margin-bottom: 20px;
        .introduce {
          width: 120px;
          height: 100%;
          span {
            color: rgb(241, 33, 33);
          }
        }
      }
    }
  }
}
</style>
<style lang='less'>
.search {
  .ivu-input-icon-clear {
    display: none;
    right: 70px;
  }
}
</style>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .header {
    width: 100%;
    height: 36px;
    line-height: 36px;
    display: flex;
    margin-top: 12px;
  }
  .ivu-modal {
    top: 0;
  }
}
</style>
<template>
  <div class="main">
    <div v-show="newUser">
      <div class="header">
        <i-button type="primary" class="loginButton" @click="AddNew">新增</i-button>
        <div class="search">
          <Input
            @on-search="GetTeacherList"
            @on-change="GetTeacherList"
            v-model="userId"
            clearable
            search
            enter-button="搜索"
            placeholder="输入老师姓名或手机号"
            style="width:360px;"
          />
        </div>
      </div>
      <div class="content">
        <i-table border :columns="teacherShowList" :data="showList"/>
        <Modal title="提示" v-model="del" @on-ok="DeleteTeacher" class-name="vertical-center-modal">
          <p>此操作将会移除老师，是否继续？</p>
        </Modal>
        <Modal title="提示" v-model="edit" @on-ok="ChangeTeacher" class-name="vertical-center-modal">
          <div class="header">
            老师电话：
            <Input disabled :placeholder="tMobile" style="width:280px;margin-top:2px;" />
          </div>
          <div class="header">
            老师姓名：
            <Input v-model="delName" :placeholder="delName" style="width:280px;margin-top:2px;" />
          </div>
        </Modal>
      </div>
      <div class="footer">
        <Page
          :total="count"
          :page-size="pageSize"
          :page-size-opts="[10,20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <div v-show="!newUser">
      <div class="create-new">
        <div class="header">
          <Button @click="Reback" type="primary" style="height: 36px;">
            <Icon type="ios-arrow-back" />返回
          </Button>
          <div class="message">新增教师</div>
        </div>
        <div class="content">
          <div class="tab-tips">
            <div class="introduce">
              <span>*</span>教师电话
            </div>
            <Input
              v-model="newTeacherTel"
              placeholder="请输入教师电话"
              style="width:280px;margin-top:8px;"
            />
          </div>
          <div class="tab-tips">
            <div class="introduce">
              <span>&nbsp;</span>教师姓名
            </div>
            <Input
              v-model="newTeacherName"
              placeholder="请输入教师姓名"
              style="width:280px;margin-top:8px;"
            />
          </div>
          <div class="tab-tips">
            <div class="introduce"/>
            <i-button type="primary" class="loginButton" @click="CreatNewUser">确定</i-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import analysisApi from '@/lib/api/analysis'
import schoolApi from '@/lib/api/school'
export default {
  name: '',
  data() {
    return {
      userId: '',
      del: false,
      edit: false,
      newUser: true,
      count: 0,
      number: 6,
      start: 0,
      pageSize: 10,
      list: [],
      showList: [],
      delID: '', // 删除的ID
      editID: '', // 编辑的ID
      delName: '', // 编辑的老师原姓名
      tMobile: '',
      newname: '',
      newTeacherTel: '', // 新增教师电话
      newTeacherName: '', // 新增教师姓名
      teacherShowList: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '老师姓名',
          key: 'name'
        },
        {
          title: '老师昵称',
          key: 'nickname'
        },
        {
          title: '老师手机',
          key: 'mobile'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            const editBtn = h('i-button', {
              on: {
                click: () => {
                  this.Check(params.row.mobile, params.row.id, params.row.name)
                }
              },
              props: {
                type: 'primary'
              }
            }, '编辑')
            const emptyBox = h('div', {
              style: {
                width: '16px'
              }
            })
            const delBtn = h('i-button', {
              on: {
                click: () => {
                  this.SureDel(params.row.id)
                }
              },
              props: {
                type: 'error'
              }
            }, '移除')
            return h('div', {
              style: {
                display: 'flex'
              }
            }, [editBtn, emptyBox, delBtn])
          }
        }
      ]
    }
  },
  created() {
    this.GetTeacherList()
  },
  methods: {
    AddNew() {
      this.newUser = false
    },
    Reback() {
      this.newUser = true
    },
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.GetTeacherList()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.GetTeacherList()
    },
    // 新建老师
    CreatNewUser() {
      schoolApi.CreateTeacher({
        mobile: this.newTeacherTel,
        name: this.newTeacherName
      }).then(res => {
        if (res.status == 1) {
          this.$Message.info('添加成功')
          this.newTeacherTel = ''
          this.newTeacherName = ''
          this.newUser = true
          this.GetTeacherList()
        } else {
          alert(res.msg)
        }
      })
    },
    // 编辑
    Check(phone, id, name) {
      this.tMobile = phone
      this.editID = id
      this.edit = true
      this.delName = name
      console.log(this.editID)
    },
    // 移除按钮
    SureDel(id) {
      this.del = true
      this.delID = id
    },
    // 取消删除
    Nodel() {
      this.del = false
      this.edit = false
    },
    // 确认删除
    DeleteTeacher() {
      schoolApi.DelTeacher({
        id: this.delID
      }).then(result => {
        this.del = false
        this.$Message.info('删除成功')
        this.GetTeacherList()
      })
    },
    // 编辑老师
    ChangeTeacher() {
      schoolApi.EditTeacher({
        id: this.editID,
        name: this.delName
      }).then(result => {
        if (result.status == 1) {
          this.$Message.info('修改成功')
        } else {
          this.$Message.info(result.msg)
        }
        this.edit = false
        this.GetTeacherList()
      })
    },
    // 获取教师列表
    GetTeacherList() {
      analysisApi
        .GetTeacherList({
          keyword: this.userId,
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          console.log(res)
          const teacherInfo = res
          this.list = teacherInfo.data.list // 所有数据
          this.count = teacherInfo.data.count // 总条数
          this.showList = this.list
        })
    }
  }
}
</script>
